import _isEmpty from 'lodash/isEmpty';

export const accessTiaaElements = () => {
  const elements = {};
  //Old header uses the triage class, but new header does not
  elements.triageNav = document.querySelector('body .triage') || {};
  //#mobile-primary-navigation is new TIAA mobile header
  elements.mobileNav =
    document.querySelector('.navbar.navbar-mobile') ||
    document.querySelector('#mobile-primary-navigation') ||
    {};
  elements.tiaaFooter = document.querySelector('body > footer') || {};
  elements.tiaaHeader =
    // #tiaa-global-nav is new TIAA header
    document.querySelector('#tiaa-global-nav') ||
    document.querySelector('body > header') ||
    document.querySelector('body > div > header') ||
    document.querySelector('body > div.cmp-container > div.header') ||
    document.querySelector('div.header > header') ||
    document.querySelector('mytiaa-nav-header') || // MyTIAA header 01/09/2024 (custom element)
    {};

  return elements;
};

export const calculateOffsets = elements => {
  let offsetTop =
    (elements?.triageNav?.offsetHeight || 0) +
    (elements?.tiaaHeader?.offsetHeight || elements?.mobileNav?.offsetHeight || 0);
  //if the triage nav is present and if the header is not collapsed, then we need to account for the header height
  if (!_isEmpty(elements?.triageNav)) {
    const useElementOffset = document.documentElement.scrollTop <= elements?.triageNav?.offsetHeight;
    if (!useElementOffset) {
      offsetTop = offsetTop - elements?.triageNav?.offsetHeight;
    }
  }
  return offsetTop;
};
